angular
  .module('mandaeApp')
  .directive('addShadowOnScroll', function ($document) {
    'use strict';
    return {
      restrict: 'A',
      link: function (scope, element) {
        var waitInMs = 200;
        $document.on('scroll', _.throttle(function() {
          element.toggleClass('has-bottom-shadow', $document.scrollTop() !== 0);
        }, waitInMs));
      },
    };
  });
